import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { LhStorageService } from '@hssa-itasia/ngx-util-core';
import { AppService } from '../app.service';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
@Component({
  selector: 'questionaire-radiobutton',
  standalone: true,
  imports: [IonicModule, CommonModule, ReactiveFormsModule, FormlyModule],
  styles: [`
        .not-appear{
          border-radius: 50%;
          border: 1px solid #D9D9D9;
          color: black;
          font-size: 10px;
          text-align: center;
          padding-top: 13px;
          font-weight: 600;
          height: 40px;
          width: 40px;
          
        }
        .not-appear-selected{
          border-radius: 50%;
          border: 1px solid #D9D9D9;
          color: white;
          font-size: 10px;
          text-align: center;
          padding-top: 13px;
          font-weight: 600;
          height: 40px;
          width: 40px;
          background:grey;
        }
        
        .image-size{
          margin-left: 30%;
          padding:4px;
        }
        .image-size-selected{
          margin-left: 30%;
          border: 1px solid grey;
          margin-right: 30%;
          padding: 4px;
        }
        .thums_up{
          height: 24px;
          width: 24px;
          padding: 0;
          margin: 0;
          display: block;
        }
        .thums_down{
          height: 24px;
          width: 24px;
          border-radius: 50%;
          padding: 0;
          margin: 0;
          display: block;
        }
        .thums_up_selected{
          height: 20px;
          width: 20px;
          border-radius: 50%;
          padding: 0;
          margin: 0;
          display: block;
        }
        .thums_down_selected{
          height: 24px;
          width: 24px;
          border-radius: 50%;
          padding: 0;
          margin: 0;
          display: block;
        }
        .n_a_col{
          background:grey;
        }
        .row_border{
          padding-top: 10px;
        }
        .row_border_label{
          border-top:2px solid #EDF5F5;
          padding:10px;
      }
      .space-between{
        margin-left:14px;
      }
      .thums_down_selected_div{
        border-radius:50%;
        padding:0;
        background:#F000144D;
        height:40px;
        width:40px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .thums_down_div{
        padding: 0;
        border-radius:50%;
        height:40px;
        width:40px;
        border: 0.1em solid #F000144D;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .questions_row{
        margin-top:-10px;width:100%;margin-left: 20px;
      }
      .questions_row input {display: none; }
      .lottie_animation_div{
        background:#0091464D;
        border-radius:50%;
        height:40px;
        width:40px;
        padding:0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .thums_up_div{
        padding:0;
        border-radius:50%;
        border: 0.1em solid #0091464D;
        height:40px;
        width:40px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .thums_up_container{
        margin-left:10px;
      }
      .questions_label{
        float:left;margin-left:6px;margin-left:28px;
          margin-top:0px;
          font-size:12px;color:#000000;
      }
      .question_count{
        float:left;color:#000000;font-weight:600;
        font-size:10px;
      }
      .lottie_player{
        border-radius:50%;
        height: 40px;
        width: 40px;
      }
      
    `],
  template: `
      <ion-row class="row_border_label">
          <ion-col size="1" class="ion-align-self-center">
            <div class="question_count">
              <ion-label>{{to.count}}</ion-label>
            </div>
          </ion-col>
          <ion-col class="ion-text-left ion-align-self-center">
            <div class="questions_label">
                <ion-label>{{to.label}}</ion-label>
            </div>
          </ion-col>     
      </ion-row>
      <ion-row class="questions_row" id="{{to.label}}">
              <ion-col size="1" class="ion-align-self-center">
              </ion-col>
              <ion-col style="display:flex;" class="ion-text-left ion-align-self-center">
                <input type="checkbox"  class="" [name]="cvpc_questionnaire_button"
                [formControl]="formControl" 
                [formlyAttributes]="field"
                [value]="option" 
                aria-label="thums_up_test"
                role="thums_up_test" 
                Accessibility-ID="thums_up_test"
                >
                  <div class="thums_up_container"  aria-label="thums_up1_test"
                role="thums_up1_test" 
                Accessibility-ID="thums_up1_test" *ngIf="to.onText=='Effective'"  (click)="updateFormValue($event,'Effective')">
                    <div class="thums_up_div" *ngIf="formControl.value !='Effective'">  
                      <ion-icon class="thums_up" aria-label="thums_up2_test"
                role="thums_up2_test" 
                Accessibility-ID="thums_up2_test"  src='assets/img/bog_tour/like_icon.svg'></ion-icon>
                    </div>
                    <div  class='thums_up_div lottie_animation_div'  *ngIf=" formControl.value == 'Effective' ">
                        <ion-icon class="thums_up_selected" aria-label="thums_up1_test" role="thums_up1_test" Accessibility-ID="thums_up1_test" src='assets/img/bog_tour/thumbs_up_selected.svg'></ion-icon>
                        <!-- <lottie-player *ngIf="appservice.connectionState" src="assets/area-management/Thumb like.json" background="transparent" speed="1" class="lottie_player"  speed="1" loop
                          mode="normal"  autoPlay></lottie-player> -->
                      </div>
                  </div>
              
                  <div class="space-between" *ngIf="to.offText=='Not Effective'"
                    (click)="updateFormValue($event,'Not Effective')" aria-label="thums_down_test"
                role="thums_down_test" 
                Accessibility-ID="thums_down_test" >
                    <div class="thums_down_div" *ngIf="formControl.value !='Not Effective' ">
                      <ion-icon class="thums_down" aria-label="thums_down1_test"
                role="thums_down1_test" 
                Accessibility-ID="thums_down1_test"  src='assets/img/bog_tour/thums_down.svg'></ion-icon>
                    </div>
                    <div class="thums_down_selected_div" *ngIf="formControl.value == 'Not Effective' ">
                      <ion-icon  class="thums_down_selected" aria-label="thums_down2_test"
                role="thums_down2_test" 
                Accessibility-ID="thums_down2_test"  src='assets/img/bog_tour/thums_down_selected.svg'></ion-icon>
                    </div>
                  </div>

                  <div class="space-between" *ngIf="to.not_applicable=='Not Applicable'">
                      <div  *ngIf="formControl.value !='Not Applicable'" aria-label="not-appear1-test"
                role="not-appear1-test" 
                Accessibility-ID="not-appear1-test"  class="not-appear" (click)="updateFormValue($event,'Not Applicable')">
                            N/A
                      </div>
                      <div  *ngIf="formControl.value =='Not Applicable' " aria-label="not-appear2-test"
                role="not-appear2-test" 
                Accessibility-ID="not-appear2-test" class="not-appear-selected" (click)="updateFormValue($event,'Not Applicable')">
                            N/A
                      </div>
                  </div>
                </ion-col>
          </ion-row>
    `
})

export class QuestionaireRadioButtonFormlyType extends FieldType {
  cvpc_questionnaire_button: any;
  option: any;
  constructor(public lhStorage: LhStorageService, public appservice: AppService) {
    super();
  }
  async ngOnInit() {
    console.log("197 to=", this.to);
    this.formControl.setValue(this.to.default_value);
  }

  updateFormValue(event, name) {
    if (this.to.disabled) {
      return
    }
    this.formControl.setValue(name);

  }

}
